/** Shared MUI TextField props for report toolbar date pickers. */
export const reportDatePickerSlotProps = {
    textField: {
        size: 'small',
        variant: 'outlined',
        fullWidth: true,
    },
};
